import React from "react"

const PageBreak = () => (
  <hr className="hidden h-0 print:block print:invisible page-break" />
)

export default PageBreak
